import jQuery from "jquery"
import Popper from "popper.js"
import "bootstrap"
import "moment/locale/fr"
import "moment/locale/nl"
Object.assign(window, { $: jQuery, jQuery })
Object.assign(window, { Popper })

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
ActiveStorage.start()

import("trix")
import("@rails/actiontext")
import("@nathanvda/cocoon")
import("@hotwired/turbo-rails")

import "../application/app"
import("../application/interactions")
import("../application/toggle-date-input")
import("../application/toggle-protocol-input-fields")
import("../application/toggle-site-schema")
import "../application/standard-modal"
import "../application/intro-modal"
import "../application/toggle-tooltip"
import "../application/selectize-input"
import "../application/setup-edit-site-form"
import "../application/select_gateway_environment"
import "../application/charts"
import "../application/secret"
import "../application/toggle-gateway-activation-form"
import "../application/announce_gw"
import "../application/conditional_form_elements"
import "../application/activation_token"
import "../application/idp_login_form"
import "../application/trix-fix"
import "../channels/consumer"
import "../controllers/index"
